/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_HintInputs */

const cs_tasks_protocol_hint = /** @type {(inputs: Tasks_Protocol_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vygenerujte PDF protokol a odešlete k elektronickému podpisu e-mailem, nebo sdílejte odkaz k podpisu. Stav se aktualizuje od Signi/DigiSign (ruční potvrzení jen v testovacím režimu podpisu).`)
};

const en_tasks_protocol_hint = /** @type {(inputs: Tasks_Protocol_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate the viewing protocol PDF, then send it for e-signature via email invite or a shareable signing link. Status updates from Signi/DigiSign (or mark signed manually in test signing mode).`)
};

/**
* | output |
* | --- |
* | "Generate the viewing protocol PDF, then send it for e-signature via email invite or a shareable signing link. Status updates from Signi/DigiSign (or mark sig..." |
*
* @param {Tasks_Protocol_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_hint = /** @type {((inputs?: Tasks_Protocol_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_hint(inputs)
	return cs_tasks_protocol_hint(inputs)
});